import { RichText } from "./RichText.js";

// maintain compatibility with old RichTextWithImageZoom
const RichTextWithImageZoom = ({ html }: { html: string }) => {
  return <RichText html={html} />;
};

export { RichTextWithImageZoom };
